type BeforeAfterView = "before" | "after";

type BeforeAfterToggleProps = {
  view: BeforeAfterView;
  onChange: (view: BeforeAfterView) => void;
};

export function BeforeAfterToggle({ view, onChange }: BeforeAfterToggleProps) {
  return (
    <div
      className="absolute left-1/2 top-3 z-20 flex -translate-x-1/2 overflow-hidden rounded-full bg-white p-1 shadow-md"
      data-testid="before-after-toggle"
    >
      <button
        type="button"
        onClick={() => onChange("before")}
        data-testid="before-after-toggle-before"
        className={`rounded-full px-4 py-1 text-sm font-medium transition-colors ${
          view === "before" ? "bg-gray-900 text-white" : "text-gray-600 hover:text-gray-900"
        }`}
      >
        Before
      </button>
      <button
        type="button"
        onClick={() => onChange("after")}
        data-testid="before-after-toggle-after"
        className={`rounded-full px-4 py-1 text-sm font-medium transition-colors ${
          view === "after" ? "bg-gray-900 text-white" : "text-gray-600 hover:text-gray-900"
        }`}
      >
        After
      </button>
    </div>
  );
}
